module.exports = __webpack_public_path__ + "static/rupert-murdoch-39a09ede8a8d149917f9938868a203e8.jpg";